import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import api from "../utils/axiosConfig";

const DirectJoinPage = () => {
  const { code } = useParams();
  const navigate = useNavigate();
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    if (!code) {
      navigate("/user-dashboard", { replace: true });
      return;
    }

    const trimmedCode = code.trim();
    const token = localStorage.getItem("token");
    const userStr = localStorage.getItem("user");

    // If user is not logged in -> save pending code & go directly to login
    if (!token && !userStr) {
      sessionStorage.setItem("pendingJoinCode", trimmedCode);
      navigate("/login", { replace: true });
      return;
    }

    // If user is logged in -> immediately join group and open it
    const joinAndRedirect = async () => {
      try {
        const res = await api.post("/groups/join", { code: trimmedCode });
        if (res.data?.groupId) {
          sessionStorage.removeItem("pendingJoinCode");
          navigate(`/group/${res.data.groupId}`, { replace: true });
        } else {
          setErrorMessage("Failed to open album.");
        }
      } catch (err) {
        console.error("Join group error:", err);
        const msg = err.response?.data?.message || "Invalid or expired album code.";
        setErrorMessage(msg);
      }
    };

    joinAndRedirect();
  }, [code, navigate]);

  return (
    <div
      style={{
        minHeight: "100vh",
        background: "#0f172a",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: "#ffffff",
        fontFamily: "system-ui, -apple-system, sans-serif",
      }}
    >
      {!errorMessage ? (
        <div style={{ textAlign: "center" }}>
          <div
            style={{
              width: "48px",
              height: "48px",
              border: "4px solid rgba(255, 255, 255, 0.2)",
              borderTopColor: "#7c3aed",
              borderRadius: "50%",
              animation: "spin 0.8s linear infinite",
              margin: "0 auto 16px",
            }}
          />
          <style>
            {`@keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }`}
          </style>
          <p style={{ fontSize: "16px", fontWeight: 600, color: "#94a3b8" }}>
            Joining album, please wait...
          </p>
        </div>
      ) : (
        <div
          style={{
            background: "#ffffff",
            color: "#0f172a",
            padding: "32px 24px",
            borderRadius: "20px",
            textAlign: "center",
            maxWidth: "380px",
            width: "90%",
            boxShadow: "0 20px 40px rgba(0, 0, 0, 0.4)",
          }}
        >
          <div style={{ fontSize: "36px", marginBottom: "12px" }}>⚠️</div>
          <h3 style={{ margin: "0 0 8px", fontSize: "18px", fontWeight: 800 }}>
            Unable to Join Album
          </h3>
          <p style={{ color: "#64748b", fontSize: "14px", margin: "0 0 20px" }}>
            {errorMessage}
          </p>
          <button
            onClick={() => {
              const user = localStorage.getItem("user");
              if (user) {
                try {
                  const parsed = JSON.parse(user);
                  navigate(parsed.role === "admin" ? "/admin-dashboard" : "/user-dashboard");
                  return;
                } catch (e) { }
              }
              navigate("/login");
            }}
            style={{
              background: "#7c3aed",
              color: "#ffffff",
              border: "none",
              borderRadius: "10px",
              padding: "10px 20px",
              fontWeight: 700,
              cursor: "pointer",
            }}
          >
            Go to Dashboard
          </button>
        </div>
      )}
    </div>
  );
};

export default DirectJoinPage;
